import { render, staticRenderFns } from "./ChangePartnerPlanModal.vue?vue&type=template&id=51975924&"
import script from "./ChangePartnerPlanModal.vue?vue&type=script&lang=js&"
export * from "./ChangePartnerPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports